import request from '@/utils/request'

// 查询剧本赞助列表
export function listSponsor(query) {
  return request({
    url: '/script/sponsor/list',
    method: 'get',
    params: query
  })
}

// 查询剧本赞助详细
export function getSponsor(id) {
  return request({
    url: '/script/sponsor/' + id,
    method: 'get'
  })
}

// 新增剧本赞助
export function addSponsor(data) {
  return request({
    url: '/script/sponsor',
    method: 'post',
    data: data
  })
}

// 修改剧本赞助
export function updateSponsor(data) {
  return request({
    url: '/script/sponsor',
    method: 'put',
    data: data
  })
}

// 删除剧本赞助
export function delSponsor(id) {
  return request({
    url: '/script/sponsor/' + id,
    method: 'delete'
  })
}
